import 'react-image-gallery/styles/css/image-gallery.css';
import './thumbs-gallery.css';
import 'react-medium-image-zoom/dist/styles.css';

import ImageGallery from 'react-image-gallery';
import Zoom from 'react-medium-image-zoom';

import FilePreview from './FilePreview';

interface ThumbsGalleryProps {
  media: Array<{
    url: string;
    name: string;
    type: string;
  }>;
  itemTitle: string;
}

/**
 * Build a thumbnail URL. Prefer CDN resize params when supported, but never
 * produce a broken double-`?` query (e.g. `file.png?x=1?w=250`).
 */
const toThumbnailUrl = (url: string): string => {
    try {
        const parsed = new URL(url);
        if (!parsed.searchParams.has('w')) {
            parsed.searchParams.set('w', '250');
            parsed.searchParams.set('h', '150');
            parsed.searchParams.set('fit', 'crop');
        }
        return parsed.toString();
    } catch {
        return url;
    }
};

const ThumbsGallery = ({ media, itemTitle }: ThumbsGalleryProps) => {

    const images = media.map((item) => ({
        original: item.url,
        thumbnail: toThumbnailUrl(item.url),
        description: itemTitle,
        thumbnailHeight: 100,
    }));

    return (
        <div className="image-gallery-container">
            <ImageGallery
                items={images.map((item) => ({
                    ...item,
                    renderItem: (props) => (
                        <Zoom>
                            <FilePreview url={props.original} alt={props.description} className='tw-flex tw-justify-center tw-items-center tw-py-2' />
                        </Zoom>
                    ),
                }))}
                showThumbnails={true}
                showFullscreenButton={false}
                showPlayButton={false}
                thumbnailPosition="bottom"
                lazyLoad={true}
                renderThumbInner={(item) => (
                    <div className="tw-overflow-hidden">
                        <div className='tw-flex tw-justify-center tw-items-center tw-py-2'>
                            <FilePreview
                                url={item.thumbnail || ''}
                                alt={item.thumbnailAlt || ''}
                                showAsIconPreview={true}
                                className='tw-object-cover !tw-h-8'/>
                        </div>
                    </div>
                )}
            />
        </div>
    );
};

export default ThumbsGallery;
